import * as GrandPrixService from "../../../services/GrandPrixService";
import useResource from "../../../hooks/UseResource";

export default function useGrandPrix(id) {
    return useResource(id, GrandPrixService.findGrandPrixById);
}
